import React, { useEffect } from 'react';

import { TableNumberHeader } from '../../../components/partials/TableNumberHeader';
import * as Api from '../../../weborder/Api';
import { checkoutUtils } from '../../OrderCheckout/utils';
import { getRestaurantNotes } from '../utils/locationHeaderUtils';
import { LocationHeader } from './LocationHeader';

type Props = {
  currency: Api.Currency;
  deliveryLocation: Api.DeliveryLocation | null;
  hasLockedTableNumber: boolean;
  languageCode: string;
  prId: number;
  restaurant: Api.CollectionRestaurantDetail | Api.DeliveryRestaurantDetail;
  setTableLock: (prid: number, isEnabled: boolean) => void;
  tableNumber: number;
  translate: any;
  type: string;
  vrId: number;
};

export function StoreHeader(props: Props): JSX.Element {
  const {
    currency,
    deliveryLocation,
    hasLockedTableNumber,
    languageCode,
    prId,
    restaurant,
    setTableLock,
    tableNumber,
    translate,
    type,
    vrId,
  } = props;

  const isCollection = restaurant.DeliveryType === Api.DeliveryType.Collection;

  const locationAreaOptions = isCollection
    ? restaurant.LocationAreas
    : undefined;

  useEffect(() => {
    const isValidTable = (
      tableId: number,
      locationAreas: Api.LocationArea[],
    ): boolean =>
      locationAreas.some((locationArea) =>
        locationArea.Locations.some(
          (location) => location.LocationId === tableId,
        ),
      );

    const isTableLoadingComplete =
      locationAreaOptions && tableNumber && hasLockedTableNumber;

    if (isTableLoadingComplete) {
      const isEnabled =
        locationAreaOptions?.length > 0
          ? isValidTable(tableNumber, locationAreaOptions)
          : true;
      setTableLock(prId, isEnabled);
    }
  }, [locationAreaOptions, tableNumber]);

  const isTableLockEnabled = isCollection
    ? restaurant.IsTableLockEnabled
    : undefined;

  const hasValidTable = isTableLockEnabled && hasLockedTableNumber;

  const showTableHeader =
    hasValidTable !== undefined ? hasValidTable : hasLockedTableNumber;

  if (isCollection && showTableHeader) {
    const { serviceTypes, tableServiceCategory } =
      checkoutUtils.getRestaurantLocationMeta(restaurant, type);

    const restaurantNotes = getRestaurantNotes(
      restaurant,
      currency,
      languageCode,
      translate,
    );

    return (
      <TableNumberHeader
        locationAreas={locationAreaOptions}
        restaurantNotes={restaurantNotes}
        serviceTypes={serviceTypes}
        tableNumber={tableNumber}
        tableServiceCategory={tableServiceCategory}
        translate={translate}
        vrid={vrId}
      />
    );
  }

  return (
    <LocationHeader
      currency={currency}
      deliveryLocation={deliveryLocation}
      languageCode={languageCode}
      restaurantData={restaurant}
      translate={translate}
    />
  );
}
